function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
import { DeviceType } from '@sky-uk-ott/client-lib-js-device';
import { CoreVideoInternal } from '../../../../core-video-internal';
import { PlayerType } from '../../../../core/player/player-type';
import { PrefetchNoneController } from './strategy-controllers/prefetch-none-controller';
import { PrefetchQueueController } from './strategy-controllers/prefetch-queue-controller';
import { standardFetch } from './thumbnail-fetch-methods';
export var ThumbnailPrefetchFactory = /*#__PURE__*/ function() {
    "use strict";
    function ThumbnailPrefetchFactory() {
        _class_call_check(this, ThumbnailPrefetchFactory);
    }
    _create_class(ThumbnailPrefetchFactory, null, [
        {
            key: "createThumbnailPrefetchController",
            value: function createThumbnailPrefetchController() {
                var fetcher = ThumbnailPrefetchFactory.getFetcher();
                return ThumbnailPrefetchFactory.getPrefetchController(fetcher);
            }
        },
        {
            key: "getFetcher",
            value: function getFetcher() {
                return standardFetch;
            }
        },
        {
            key: "getPrefetchController",
            value: function getPrefetchController(fetcher) {
                // TODO: Get requirements for which strategy to use on each device
                if (CoreVideoInternal.deviceType === DeviceType.Browser) {
                    return new PrefetchQueueController(fetcher, {
                        concurrentFetches: 2,
                        delayBetweenFetchesMs: 0
                    });
                }
                if ([
                    PlayerType.DualPlayer,
                    PlayerType.Shaka,
                    PlayerType.Android
                ].includes(CoreVideoInternal.playerType) && CoreVideoInternal.deviceType !== DeviceType.WebOS) {
                    return new PrefetchQueueController(fetcher, {
                        concurrentFetches: 1,
                        delayBetweenFetchesMs: 1000
                    });
                }
                return new PrefetchNoneController(fetcher);
            }
        }
    ]);
    return ThumbnailPrefetchFactory;
}();

//# sourceMappingURL=thumbnail-prefetch-factory.js.map